import { BKJButton } from '@bookjane2/bookjane-design-library';
import { Flex } from 'components/Flex';
import { groupsModalRoutingService } from 'pages/Settings/modals/GroupsModal/GroupsModal.ui.context';
import {
  groupsPageEmptyHeaderCopy,
  groupsPageEmptyBodyCopy,
} from 'pages/Settings/pages/LocationSettings/pages/Groups/GroupsPageEmptyView/GroupsPageEmptyView.constants';
import {
  EmptyBody,
  EmptyHeader,
  EmptyMessage,
  EmptyViewWrapper,
} from 'pages/Settings/pages/LocationSettings/pages/Groups/GroupsPageEmptyView/GroupsPageEmptyView.styled';

export function GroupsPageEmptyView() {
  return (
    <EmptyViewWrapper>
      <Flex
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <EmptyMessage>
          <EmptyHeader>{groupsPageEmptyHeaderCopy}</EmptyHeader>
          <EmptyBody>{groupsPageEmptyBodyCopy}</EmptyBody>
        </EmptyMessage>
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          onClick={() => groupsModalRoutingService.open({}, 'NewGroup')}
        >
          Create a group
        </BKJButton>
      </Flex>
    </EmptyViewWrapper>
  );
}
